import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { eventDataFilterParamsAtom } from '@/atoms/queries/eventData';
import { playerAggsBaseFiltersAtom } from '@/atoms/queries/player/playerAggData';
import { filterSetIdAtom } from '@/atoms/queryParams';
import { TopBar } from '@/components/topBar/TopBar';
import { TopBarHeading } from '@/components/topBar/TopBarHeading';
import { layoutScopeAtoms } from '@/consts/scope';
import { FILTER_SET_ID } from '@/consts/searchKeys';
import { useSetAtomFromParams } from '@/hooks/queryParams/useSetAtomFromParams';
import { useAutoResetSelectionLayer } from '@/hooks/useAutoResetSelectionLayer';
import { useResetFiltersOnAreaEntry } from '@/hooks/useResetFiltersOnAreaEntry';
import { AppShellContents } from '../AppShell';
import { SectionWrapper } from '../SectionWrapper';

const DataLockerInner = () => {
  const filterParams = useAtomValue(eventDataFilterParamsAtom);
  useAutoResetSelectionLayer(filterParams);
  useSetAtomFromParams(filterSetIdAtom, FILTER_SET_ID);

  return (
    <SectionWrapper section="dataLocker">
      <Outlet />
    </SectionWrapper>
  );
};

export const DataLockerLayout = () => {
  useResetFiltersOnAreaEntry();
  const { t } = useTranslation('navigation');
  const title = t('crossPlatform.primary.explore');
  return (
    <ScopeProvider atoms={[...layoutScopeAtoms, filterSetIdAtom, playerAggsBaseFiltersAtom]}>
      <AppShellContents
        topBar={
          <TopBar>
            <TopBarHeading>{title}</TopBarHeading>
          </TopBar>
        }
      >
        <DataLockerInner />
      </AppShellContents>
    </ScopeProvider>
  );
};
